<template>
    <div>
        <div class="content" ng-init="">
            <div class="one-register">
                <form>
                    <fieldset class="ask_set">
                        <div class="one-input-container in-serach">
                            <label id="idEmail" for="idEmail">
                                {{ $t('BUTTON.GLOBAL.EMAIL') }}
                            </label>
                            <input id="idEmail" type="text" autocomplete="off" v-model="email" readonly />
                        </div>
                        <div class="one-input-container inquiryType">
                            <fieldset class="ui_fieldset">
                                <select class="slt_white w100p" v-model="inquiryType">
                                    <option value="">
                                        {{ $t('FIELD.GLOBAL.INQUIRY') }}
                                        <em class="txt_mandatory">*</em>
                                    </option>
                                    <option
                                        v-for="item in inquiryTypeList"
                                        :key="'inquiryTypeList' + item.CODE"
                                        :value="item.CODE"
                                    >
                                        {{ item.CODE_NM }}
                                    </option>
                                </select>
                            </fieldset>
                            <div class="error-msg">
                                <div class="ng-hide">{{ $t('MESSAGE.FIELD.INSERT.MENDATORY') }}</div>
                            </div>
                        </div>
                        <div class="model_set" style="margin-top: 30px;">
                            <div class="one-input-container in-serach selectModelCode">
                                <label id="idModel" for="idModel">
                                    {{ $t('FIELD.GLOBAL.ETC.007') }}
                                    <em class="txt_mandatory" v-show="'N' === notRelevant">*</em>
                                </label>
                                <input
                                    id="idModel"
                                    type="text"
                                    autocomplete="off"
                                    v-model="selectModelCode"
                                    maxlength="30"
                                    @keyup.enter.stop="searchModelPopup"
                                    :readonly="notRelevant == 'Y' ? true : false"
                                    v-clearable
                                />
                                <a href="javascript:" class="in_btn_search" @click="searchModelPopup">
                                    <i class="ico_input_serach2"></i>
                                    <span class="sr_only"></span>
                                </a>
                                <div class="error-msg">
                                    <div class="ng-hide">{{ $t('MESSAGE.FIELD.INSERT.MENDATORY') }}</div>
                                </div>
                            </div>
                            <div class="one-checkBox">
                                <input
                                    type="checkbox"
                                    id="relevant"
                                    v-model="notRelevant"
                                    true-value="Y"
                                    false-value="N"
                                />
                                <label for="relevant"><span></span>{{ $t('FIELD.FAQ.NOT.RELEVANT') }}</label>
                            </div>
                        </div>
                        <div class="one-input-container in-serach" v-show="'N' === notRelevant">
                            <label id="idCategory" for="idCategory">
                                {{ $t('FIELD.GLOBAL.PRODUCT.CATEGORY') }}
                            </label>
                            <input
                                id="idCategory"
                                type="text"
                                autocomplete="off"
                                v-model="selectProductCategory"
                                readonly
                            />
                        </div>
                        <div class="one-input-container prodCateCd" v-show="'Y' === notRelevant">
                            <fieldset class="ui_fieldset set_2">
                                <div>
                                    <select class="slt_white w100p" v-model="prodCateCd1" @change="loadProducts('2')">
                                        <option value="">
                                            {{ $t('FIELD.MAJOR.PRODUCT.CATEGORY') }}
                                            <em class="txt_mandatory">*</em>
                                        </option>
                                        <option
                                            v-for="item in prodCateCd1List"
                                            :key="'prodCateCd1List' + item.CODE"
                                            :value="item.CODE"
                                        >
                                            {{ item.CODEDESC }}
                                        </option>
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100p" v-model="prodCateCd2">
                                        <option value="">
                                            {{ $t('FIELD.SUB.PRODUCT.CATEGORY') }}
                                            <em class="txt_mandatory">*</em>
                                        </option>
                                        <option
                                            v-for="item in prodCateCd2List"
                                            :key="'prodCateCd2List' + item.CODE"
                                            :value="item.CODE"
                                        >
                                            {{ item.CODEDESC }}
                                        </option>
                                    </select>
                                </div>
                            </fieldset>
                            <div class="error-msg">
                                <div class="ng-hide">{{ $t('MESSAGE.FIELD.INSERT.MENDATORY') }}</div>
                            </div>
                        </div>
                        <div class="one-input-container in-serach title">
                            <label id="idSubject" for="idSubject">
                                {{ $t('FIELD.GLOBAL.TITLE') }} <em class="txt_mandatory">*</em>
                            </label>
                            <input id="idSubject" type="text" autocomplete="off" v-model="title" v-clearable />
                            <div class="error-msg">
                                <div class="ng-hide">{{ $t('MESSAGE.FIELD.INSERT.MENDATORY') }}</div>
                            </div>
                        </div>
                        <div class="one-input-container ask_textarea questionDesc">
                            <textarea
                                class="textarea_ty w100p"
                                :placeholder="$t('FIELD.GLOBAL.QNA.DESC') + ' *'"
                                v-model="questionDesc"
                            >
                            </textarea>
                            <div class="error-msg">
                                <div class="ng-hide">{{ $t('MESSAGE.FIELD.INSERT.MENDATORY') }}</div>
                            </div>
                        </div>
                    </fieldset>
                </form>
                <div class="one-btn-wrap">
                    <button class="bt-type-b" @click="goListBack">{{ $t('BUTTON.GLOBAL.CANCEL') }}</button>
                    <button class="bt-type-b blue" @click="save">{{ $t('BUTTON.GLOBAL.SUBMIT') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import api from '@/service';
import { mapActions, mapGetters } from 'vuex';
import { SDLUtil, StringUtil } from '@/utils';
import qs from 'query-string';
import axios from 'axios';
import constants from '@/constants';
import store from '@/vuex/store';
import scrollbar from '/static/js/jquery.scrollbar.js';
import searchModelPopup from '~vb/eur/voc/RequestVocModelPopup';

export default {
    name: 'RequestRepairInfo',
    components: {
        scrollbar,
    },
    computed: {
        ...mapGetters({
            loginId: 'getLoginId',
            email: 'getEmail',
            corpNo: 'getCorpNo',
            langCd: 'getLangCd',
            countryCd: 'getCountryCd',
        }),
    },
    data() {
        return {
            modelList: [],
            selectCountryCd: '',
            selectModelCode: '',
            selectProductCategory: '',
            modelCode: '',
            notRelevant: 'N',
            inquiryType: '',
            inquiryTypeList: [],
            prodCateCd1: '',
            prodCateCd2: '',
            prodCateCd1List: [],
            prodCateCd2List: [],
            title: '',
            questionDesc: '',
        };
    },
    watch: {
        notRelevant() {
            this.modelCode = '';
            this.selectCountryCd = '';
            this.selectModelCode = '';
            this.selectProductCategory = '';
            $('#idModel')
                .parent('div.one-input-container')
                .removeClass('active');
            $('#idCategory')
                .parent('div.one-input-container')
                .removeClass('active');
        },
    },
    methods: {
        async save() {
            if (!this.userValidateion()) {
                return;
            }

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/noauth/eur/saveVocProc.skp`,
                    qs.stringify({
                        bpNo: this.loginId,
                        langCd: this.langCd,
                        inquiryType: this.inquiryType,
                        countryCd: this.selectCountryCd,
                        modelCode: this.modelCode,
                        prodCateCd1: this.prodCateCd1,
                        prodCateCd2: this.prodCateCd2,
                        vocStatus: '01',
                        title: this.title,
                        questionDesc: this.questionDesc,
                    }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);

                    SDLUtil.alert({
                        title: 'TITLE.GLOBAL.POPUP.ALERT',
                        msg: resp.data.msg,
                        onOkEvt: () => {
                            return this.goListBack();
                        },
                    });
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        userValidateion() {
            let bRes = true;

            $('.selectModelCode').removeClass('error');
            $('.prodCateCd').removeClass('error');
            if ('N' === this.notRelevant && SDLUtil.isNull(this.selectProductCategory)) {
                $('.selectModelCode').addClass('error');
                bRes = false;
            } else if ('Y' === this.notRelevant && SDLUtil.isNull(this.prodCateCd2)) {
                $('.prodCateCd').addClass('error');
                bRes = false;
            }

            let valids = [this.inquiryType, this.title, this.questionDesc];
            let classNm = ['inquiryType', 'title', 'questionDesc'];

            $.each(valids, function(idx, elm) {
                if (!elm) {
                    $('.' + classNm[idx]).addClass('error');
                    bRes = false;
                } else {
                    $('.' + classNm[idx]).removeClass('error');
                }
            });
            return bRes;
        },
        goListBack() {
            this.$router.push(`${SDLUtil.WEB_CONTEXT_PATH}/erp/repairInfoHist`);
        },
        async loadProducts(v, code) {
            if ('2' === v && SDLUtil.isNull(this.prodCateCd1)) {
                this.prodCateCd2 = '';
                this.prodCateCd2List = [];
                return false;
            }

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/noauth/eur/productCategories.skp`,
                    qs.stringify({
                        parentCode: this.prodCateCd1,
                        level: SDLUtil.nvl(v),
                        code: SDLUtil.nvl(code),
                    }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);

                    let reLevel = resp.data.search.level,
                        reCode = resp.data.search.code,
                        reResult = resp.data.result.rowData;

                    if ('1' === reLevel) {
                        this.prodCateCd1List = reResult;
                    } else if ('2' === reLevel) {
                        if (SDLUtil.isNull(reCode)) {
                            this.prodCateCd2 = '';
                        } else {
                            this.prodCateCd2 = reCode;
                        }
                        this.prodCateCd2List = reResult;
                    }
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async getInquiryCodeList(v) {
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/noauth/eur/getNationLangCodes.skp`,
                    qs.stringify({ groupCd: v, corpNo: this.corpNo, langCd: this.langCd }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    this.inquiryTypeList = resp.data.rows;
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        searchModelPopup() {
            if ('Y' === this.notRelevant) {
                return false;
            }
            let searchModel = this.selectModelCode;
            SDLUtil.show(
                searchModelPopup,
                {
                    searchModel,
                    rtnFunc: (arg1, arg2, arg3, arg4, arg5) => {
                        this.modelCode = arg2;
                        this.selectCountryCd = arg1;
                        this.selectModelCode = arg2;
                        this.selectProductCategory = arg3;
                        this.prodCateCd1 = arg4;
                        this.prodCateCd2 = arg5;
                        this.loadProducts('2', arg5);
                        $('#idModel')
                            .parent('div.one-input-container')
                            .addClass('active');
                        $('#idCategory')
                            .parent('div.one-input-container')
                            .addClass('active');
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        inputEvent() {
            let $inputs = $('form').find(':input');
            $inputs.each(function() {
                let $input = $(this),
                    $label = $input.parent('div.one-input-container');
                if ($input.val()) $label.addClass('active');

                $input.focusin(function() {
                    $label.addClass('focus');
                    $label.siblings('div.flexbdy').addClass('off');
                });
                $input.change(function() {
                    $label.addClass('active');
                });
                $input.focusout(function() {
                    $label.removeClass('focus');
                });
            });
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.inputEvent();
            this.loadProducts('1');
            this.getInquiryCodeList('I');
        });
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/voc/RequestQuestion.vue